var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M2.8 9.645h14.4c.442 0 .8.347.8.774v3.097H2V10.42c0-.427.358-.774.8-.774Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M18 13.516v.774a.787.787 0 0 1-.8.775H2.8a.787.787 0 0 1-.8-.775v-.774M2.8 15.065V17M17.2 15.065V17M2.8 9.645V6.548C2.8 5.693 3.516 5 4.4 5h11.2c.883 0 1.6.693 1.6 1.548v3.097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M2.8 9.645c0-1.283 1.074-2.322 2.4-2.322h2.4c1.325 0 2.4 1.04 2.4 2.322M10 9.645c0-1.283 1.075-2.322 2.4-2.322h2.4c1.325 0 2.4 1.04 2.4 2.322"
  })));
};
export default SvgBed;